import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'SaaSCTA',
  data () {
    return {
      isLoading: { checkout: false }
    }
  },
  computed: {
    ...mapGetters(['activeWorkspace']),
    workspaceId () {
      return parseInt(this.$route.params.workspaceId)
    }
  },
  methods: {
    ...mapActions(['createStripeCheckoutSession']),
    ...mapMutations(['setSnackbar']),
    async redirectToCheckout () {
      this.isLoading.checkout = true
      const environment = process.env.NODE_ENV
      console.log('environment', environment)
      const response = await this.createStripeCheckoutSession({
        workspaceId: this.workspaceId,
        productId: environment === 'production' ? 'prod_QURplDCgMZ26zV' : 'prod_SOrETtgZIw7HTc' // ContentGecko Mini product ID
      })
      const redirectURL = response && response.url
      this.isLoading.checkout = false
      if (redirectURL) {
        // Check if this was a subscription update (direct redirect) or new checkout (open in same window)
        if (response.subscription_updated) {
          this.setSnackbar({
            open: true,
            text: 'Subscription updated successfully! Refresh the page to continue',
            type: 'success'
          })
        } else {
          // Open in same window for new subscriptions in SaaS context
          window.location.href = redirectURL
        }
      }
    }
  }
}
